// Styles here will override Bulma styles
import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const StyledContent = styled.div`
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    color: #5b6987;

    img {
      max-width: 100%;
      margin: 20px 0;
    }

    strong {
      font-weight: 600;
      font-family: 'WorkSans-Regular';

      //inline code style
      em {
        padding: 3px 8px;
        margin: 2px;
        background: #f9fafb;
        font-size: 15px;
        color: #697595;
        font-family: 'Cousine-Regular', monospace !important;
        border-radius: 4px;
        font-style: normal;
      }
    }

    a {
      color: hsl(215, 100%, 50%);

      :hover {
        text-decoration: underline;
      }
    }
  }

  iframe {
    padding: 24px 0;
    ${media('>= tablet')} {
      min-width: 560px;
      min-height: 340px;
    }
    ${media('>= desktop')} {
      min-width: 790px;
      min-height: 475px;
    }
  }

  pre {
    padding: 16px;
    margin: 8px 0;
    background: #f9fafb;
    font-size: 15px;
    color: #697595;
    font-family: 'Cousine-Regular', monospace !important;
    border-radius: 4px;
    font-style: normal;
    overflow: scroll;
  }

  h1 {
    color: #5b6987;
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 36px;
    letter-spacing: 0px;
  }

  h2,
  h3,
  h4,
  h5 {
    font-family: 'WorkSans-Bold';
    font-style: normal;
    font-weight: normal;
    line-height: 30px;
    color: #031b4e;
    margin-top: 40px;
    margin-bottom: 0px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 22px;
    line-height: 38px;
  }

  h4 {
    font-size: 20px;
  }

  h5 {
    font-size: 18px;
  }

  h6 {
    font-size: 16px;
  }

  ul,
  ol {
    color: #5b6987;
    font-family: 'WorkSans-Light';
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 17px;

    li {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 26px;
      color: #5b6987;

      a {
        color: hsl(215, 100%, 50%) !important;
      }
    }
  }
`;
